export default ({ request }) => ({
  stockCheckTaskListApi(data = {}) {
    return request({
      url: '/samplemanage/stockCheckTask/list',
      method: 'post',
      data
    })
  },
  stockCheckTaskDetailApi(data = {}) {
    return request({
      url: '/samplemanage/stockCheckTask/detail',
      method: 'post',
      data
    })
  },
  stockCheckTaskRangeDetailListApi(data = {}) {
    return request({
      url: '/samplemanage/stockCheckTask/rangeDetailList',
      method: 'post',
      data
    })
  },
  stockCheckTaskGetRangeListApi(data = {}) {
    return request({
      url: '/samplemanage/stockCheckTask/getRangeList',
      method: 'post',
      data
    })
  },
  stockCheckTaskSaveApi(data = {}) {
    return request({
      url: '/samplemanage/stockCheckTask/save',
      method: 'post',
      data
    })
  },
  stockCheckTaskDelApi(data = {}) {
    return request({
      url: '/samplemanage/stockCheckTask/del',
      method: 'post',
      data
    })
  },
  stockCheckTaskAuditApi(data = {}) {
    return request({
      url: '/samplemanage/stockCheckTask/audit',
      method: 'post',
      data
    })
  },
  stockCheckTaskFinishApi(data = {}) {
    return request({
      url: '/samplemanage/stockCheckTask/finish',
      method: 'post',
      data
    })
  }
})
